function hideLoadingWrapper() {
  document.getElementById('rr-loading-wrapper').style.display = 'none'
}

export default hideLoadingWrapper
